import { getCert } from '../lib/api.js';
import { renderCertificate } from '../components/certificate.js';
import { mountCertifyFriend } from '../components/certifyFriend.js';
import { downloadPdf } from '../lib/pdf.js';
import { shareImage } from '../lib/image.js';
import { renderNotFound } from './notFound.js';

export async function renderRecipient(root, { id }) {
  let cert;
  try { cert = await getCert(id); }
  catch { return renderNotFound(root); }

  root.innerHTML = `
    <div class="recipient-page">
      <header class="recipient-banner">
        <div class="banner-eyebrow">— OFFICIAL RECORD —</div>
        <h1 class="banner-title">${escapeHtml(cert.name)} has been officially certified.</h1>
      </header>
      <div class="cert-host" data-test="cert-host"></div>
      <div class="recipient-cta">
        <a class="btn btn-rainbow" href="/?ref=${encodeURIComponent(cert.id)}" data-test="cta-own">Run your own investigation →</a>
      </div>
    </div>
  `;
  const certHost = root.querySelector('[data-test=cert-host]');
  renderCertificate(certHost, cert);

  certHost.querySelector('[data-test=download-pdf]').addEventListener('click', () => {
    downloadPdf(certHost.querySelector('.certificate'), cert);
  });
  certHost.querySelector('[data-test=share-image]').addEventListener('click', () => {
    shareImage(certHost.querySelector('.certificate'), cert);
  });
  certHost.querySelector('[data-test=order-printed]').addEventListener('click', () => {
    window.location.assign(`/checkout/${cert.id}`);
  });
  const friendBtn = certHost.querySelector('[data-test=certify-friend]');
  friendBtn.addEventListener('click', () => {
    if (certHost.querySelector('[data-test=certify-friend-form]')) return;
    const formHost = document.createElement('div');
    certHost.appendChild(formHost);
    mountCertifyFriend(formHost, { referrerId: cert.id });
  });
}

function escapeHtml(s) {
  return s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}
